import {createApp} from 'vue'
import FrivilligePostsList from './FrivilligePostsList'

const el = '.kb-component--frivillige-posts-list'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FrivilligePostsListDOM)=>{
            const props = {
                isMember: FrivilligePostsListDOM.hasAttribute('is-member'),
                isLoggedIn: FrivilligePostsListDOM.hasAttribute('is-logged-in'),
                guid: FrivilligePostsListDOM.dataset.guid,
                groupId: FrivilligePostsListDOM.dataset.groupId,
                featuredPostSpotCards: FrivilligePostsListDOM.dataset.featuredPostSpotCards 
                    ? JSON.parse(FrivilligePostsListDOM.dataset.featuredPostSpotCards) 
                    : null
            }
            const component = createApp(FrivilligePostsList, props).use(Store)
            component.mount(FrivilligePostsListDOM)
        })
    }

}